import React, { useState, useRef, useContext, useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { resetTemporaryAtom, setTemporaryInitDashboardAtom } from '../Services/store/atoms';
import Modal from '../Components/Modal';
import { setAuthUserAtom, setDataUserAtom, isAuthAtom, dataUserAtom } from '../Services/store/atoms';
import { FaRegUserCircle, FaSpinner } from 'react-icons/fa';
import { LuVenetianMask, LuMail, LuLock, LuKeyRound, LuEye, LuEyeOff } from 'react-icons/lu';
import { IconContext } from "react-icons";
import config from '../Config';
import DarkModeContext from '../Components/DarkModeContext';
import ModalActions from '../Components/ModalActions';
import TermsModal from '../Components/TermsModal';
import GoogleLoginButton from '../Components/GoogleLoginButton';
import ModelWelcomeStory, { GoogleSignupHint } from '../Components/ModelWelcomeStory';
import { AGE_VERIFIED_EVENT, isAgeVerified } from '../Components/AgeVerificationModal';
import LayoutHomeUser from '../Layouts/Admin/Layout';
import { getReferralCode, clearReferralCode } from './ReferralCapture';

const getUserCountry = async () => {
    try {
        const response = await axios.get('https://api.ipgeolocation.io/ipgeo?apiKey=4dd5108036e74396ac71b760775b0f39');
        return response.data.country_code2;
    } catch (error) {
        console.error('Error detecting user country:', error);
        return null;
    }
};

const getPhoneCode = (countryCode) => {
    return getCountryCallingCode(countryCode);
};

// Link compartible: si la URL trae la intención de rol, se resuelve una sola
// vez por carga de página (/registermodel, /registerclient, o /register?role=).
// Se usa para inicializar el estado directamente, como si ya se hubiera
// tocado el botón correspondiente en el modal de bienvenida.
const getRoleFromUrl = () => {
    if (typeof window === 'undefined') return null;
    if (window.location.pathname === '/registermodel') return 'model';
    if (window.location.pathname === '/registerclient') return 'client';
    const param = new URLSearchParams(window.location.search).get('role');
    return (param === 'model' || param === 'client') ? param : null;
};

function Register() {
    const initialRole = getRoleFromUrl();
    const [activeTab, setActiveTab] = useState(initialRole || 'client');
    const [isTabLocked, setIsTabLocked] = useState(!!initialRole);
    const history = useHistory();
    const setAuthUser = useSetAtom(setAuthUserAtom);
    const setDataUser = useSetAtom(setDataUserAtom);
    const resetTemporary = useSetAtom(resetTemporaryAtom);
    const setTemporaryInitDashboard = useSetAtom(setTemporaryInitDashboardAtom);
    const modalRef = useRef(null);
    const termsModalRef = useRef(null);
    const [name, setName] = useState('');
    const [nameV, setNameV] = useState(false);
    const [nickname, setNickname] = useState('');
    const [nicknameV, setNicknameV] = useState(false);
    const [email, setEmail] = useState('');
    const [emailV, setEmailV] = useState(false);
    const [emailFormatV, setEmailFormatV] = useState(true);
    const [phone, setPhone] = useState('');
    const [phoneV, setPhoneV] = useState(false);
    const [areaCode, setAreaCode] = useState('');
    const [Birthdate, setBirthdate] = useState('');
    const [BirthdateV, setBirthdateV] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordV, setPasswordV] = useState(false);
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [passwordRepeatV, setPasswordRepeatV] = useState(false);
    const [passwordRepeatVerifiedV, setPasswordRepeatVerifiedV] = useState(true);
    const [isAuth] = useAtom(isAuthAtom);
    const [dataUser] = useAtom(dataUserAtom);
    const [role, setRole] = useState(initialRole || 'client');
    const [isLoading, setIsLoading] = useState(false);
    const [hiddenRole, setHiddenRole] = useState(initialRole ? (initialRole === 'model' ? 'client' : 'model') : '');
    const [isPasswordMatch, setIsPasswordMatch] = useState(true);
    const [initialModalOpen, setInitialModalOpen] = useState(!initialRole);
    // Registro de modelo: si falta, primero la verificación de edad global ('age'),
    // luego la bienvenida tipo historia ('story'), el aviso del botón de Google
    // ('hint') y recién ahí el formulario (null).
    const startModelWelcome = () => setModelWelcome(isAgeVerified() ? 'story' : 'age');
    const [modelWelcome, setModelWelcome] = useState(
        initialRole === 'model' ? (isAgeVerified() ? 'story' : 'age') : null
    );

    useEffect(() => {
        if (modelWelcome !== 'age') return;
        const onVerified = () => setModelWelcome('story');
        window.addEventListener(AGE_VERIFIED_EVENT, onVerified);
        return () => window.removeEventListener(AGE_VERIFIED_EVENT, onVerified);
    }, [modelWelcome]);
    const { darkMode } = useContext(DarkModeContext);
    const [phoneCode, setPhoneCode] = useState('');
    const [country, setCountry] = useState('');
    const [selectedAreaCode, setSelectedAreaCode] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [zipCode, setZipCode] = useState('');
    const [acceptTerms, setAcceptTerms] = useState(false);
    const [acceptTermsV, setAcceptTermsV] = useState(false);
    const [images, setImages] = useState([]);
    const [imageV, setImageV] = useState(false);
    const [imageCount, setImageCount] = useState(0);
    const [hasShownPhoneWarning, setHasShownPhoneWarning] = useState(false);
    const [gender, setGender] = useState('');
    const [genderV, setGenderV] = useState(false);
    const [referralCode, setReferralCode] = useState('');
    const [referrerName, setReferrerName] = useState('');

    useEffect(() => {
        const stored = getReferralCode();
        if (!stored) return;
        setReferralCode(stored);

        // Resolver el nickname del referidor para mostrar un mensaje amigable.
        // Si el código es inválido o fue revocado, no se muestra nada.
        axios.get(`${config.REACT_APP_BASE_URL}/api/v1/auth/referral-info/${encodeURIComponent(stored)}`)
            .then(r => setReferrerName(r.data.nickname || ''))
            .catch(() => setReferrerName(''));
    }, []);

    useEffect(() => {
        const fetchCountryCode = async () => {
            const countryCode = await getUserCountry();
            if (countryCode) {
                const phoneCode = getPhoneCode(countryCode);
                setPhoneCode(phoneCode);
                setCountry(countryCode);
                setSelectedAreaCode(`+${phoneCode}`);
                setSelectedCountry({ value: countryCode, label: countryCode, flag: countryCode });
            }
        };

        fetchCountryCode();
    }, []);

    const handleCountryChange = (selectedOption) => {
        console.log(selectedOption)
        setSelectedCountry(selectedOption);
        setCountry(selectedOption.value);
        setZipCode(selectedOption.postal)
    };

    const handleTabChange = (tab) => {
        if (!isTabLocked) {
            setActiveTab(tab);
            setRole(tab);
        }
    };

    const handleInputFocus = () => {
        if (role == 'client') {
            setHiddenRole('model')
        }
        if (role == 'model') {
            setHiddenRole('client')
        }
        setIsTabLocked(true);
    };

    const navigate = (route) => {
        setTemporaryInitDashboard(true);
        history.push(route);
    };

    useEffect(() => {
        if (isAuth) {
            history.push('/' + dataUser.role);
        }
    }, [isAuth]);

    useEffect(() => {
        if (initialModalOpen) {
            modalRef.current.openModal(
                'warning',
                <div className="p-4 text-center">
                    <h2 className="ap-title-2">Choose your role</h2>
                    <p className="ap-subhead mt-1">Please select if you want to register as a Client or Model.</p>
                </div>,
                <div className="px-4 pb-5 sm:px-6 flex flex-col sm:flex-row justify-center items-stretch gap-3">
                    <button
                        type="button"
                        className="ap-btn ap-btn-gray w-full sm:flex-1"
                        onClick={() => {
                            handleTabChange('client');
                            setInitialModalOpen(false);
                            handleInputFocus();
                            modalRef.current.closeModal();
                        }}
                    >
                        <IconContext.Provider value={{ size: '20px' }}>
                            <FaRegUserCircle />
                        </IconContext.Provider>
                        Client
                    </button>
                    <button
                        type="button"
                        className="ap-btn ap-btn-gray w-full sm:flex-1"
                        onClick={() => {
                            handleTabChange('model');
                            setInitialModalOpen(false);
                            handleInputFocus();
                            modalRef.current.closeModal();
                            startModelWelcome();
                        }}
                    >
                        <IconContext.Provider value={{ size: '20px' }}>
                            <LuVenetianMask />
                        </IconContext.Provider>
                        Model
                    </button>
                </div>
            );
        }
    }, [initialModalOpen, darkMode]);

    const esEmailValido = (email) => {
        const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regexEmail.test(email);
    };

    const login = () => {
        console.log(role);

        let formData = new FormData();
        let message = "";

        if (!email) {
            setEmailV(true);
            message += "Enter Email -";
        } else {
            setEmailFormatV(esEmailValido(email));
        }

        if (!password) {
            setPasswordV(true);
            message += " Enter Password -";
        }

        if (!passwordRepeat) {
            setPasswordRepeatV(true);
            message += " Enter repeat password -";
        }

        if (password != passwordRepeat) {
            setPasswordV(true);
            setPasswordRepeatV(true);
            setPasswordRepeatVerifiedV(false);
            message += " Passwords do not match -";
        }

        if (!acceptTerms) {
            setAcceptTermsV(true);
            message += " Accept the terms and conditions.";
        }

        if (message !== "") {
            return;
        }

        const configHeader = {
            headers: { 'content-type': 'multipart/form-data' }
        };
        setIsLoading(true);
        formData.append('email', email);
        formData.append('name', name);
        formData.append('nickname', nickname);
        formData.append('password', password);
        formData.append('device_name', "iPhone 14");
        formData.append('role', role);
        formData.append('nationality', selectedCountry ? selectedCountry.value : '');
        formData.append('gps', zipCode);
        if (referralCode) {
            formData.append('referral_code', referralCode);
        }
        images.forEach((image, index) => {
            formData.append('images[]', image, image.name);
        });

        axios.post(`${config.REACT_APP_BASE_URL}/api/v1/auth/register`, formData, configHeader)
            .then(function (response) {
                setIsLoading(false);
                clearReferralCode();
                setReferralCode('');
                modalRef.current.openModal(
                    'success',
                    response.data.message,
                    <p className={`${darkMode ? 'text-white' : 'text-black'}`}>{"Now log in with your email and password."}</p>,
                    <ModalActions onClose={() => modalRef.current.closeModal()}>
                        <a
                            type="button"
                            className={`cursor-pointer mt-3 w-full inline-flex justify-center rounded-md shadow-sm ${darkMode ? 'bg-rose-500 hover:bg-rose-500' : 'bg-rose-500 hover:bg-rose-600'} text-white px-4 py-2 text-base font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rose-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm`}
                            onClick={() => {
                                navigate('/login');
                            }}
                        >
                            Sign In
                        </a>
                    </ModalActions>
                );

                resetForm();
            })
            .catch(function (error) {
                setIsLoading(false);
                console.log('Registration Error:', error);
                console.log('Error Response:', error.response?.data);
                
                const errorMessage = error.response?.data?.message || 'Registration failed. Please try again.';
                const errorDetails = error.response?.data?.errors || {};
                
                modalRef.current.openModal(
                    'error',
                    errorMessage,
                    <div className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-500'}`}>
                        {Object.entries(errorDetails).map(([field, messages]) => (
                            <div key={field}>
                                <strong>{field}:</strong> {Array.isArray(messages) ? messages.join(', ') : messages}
                            </div>
                        ))}
                    </div>,
                    <ModalActions onClose={() => modalRef.current.closeModal()} />
                );
            });
    };

    const resetForm = () => {
        setName('');
        setNickname('');
        setEmail('');
        setPhone('');
        setBirthdate('');
        setPassword('');
        setPasswordRepeat('');
        setGender('');
        setNameV(false);
        setNicknameV(false);
        setEmailV(false);
        setPhoneV(false);
        setBirthdateV(false);
        setPasswordV(false);
        setPasswordRepeatV(false);
        setPasswordRepeatVerifiedV(true);
        setIsTabLocked(false);
        setIsPasswordMatch(true);
        setAreaCode('');
        setSelectedAreaCode('');
        setAcceptTerms(false);
        setAcceptTermsV(false);
        setImages([]);
        setImageV(false);
        setGenderV(false);
        setHasShownPhoneWarning(false); // Restablecer el estado
    };

    // Fila con error: marca roja a la izquierda y un sacudón, como en iOS.
    const validate = (field) => {
        if (field) return "ap-row-invalid animate__animated animate__headShake";
        return "";
    };

    const handlePhoneChange = (event) => {
        const inputValue = event.target.value;
        setPhone(inputValue);

        if (!selectedAreaCode || selectedAreaCode === '+') {
            setSelectedAreaCode(`+${phoneCode}`);
        } else {
            if (!selectedAreaCode.startsWith('+')) {
                setSelectedAreaCode(`+${selectedAreaCode}`);
            }
        }
    };

    const togglePasswordVisibility = (event) => {
        event.stopPropagation();
        setShowPassword(!showPassword);
    };

    const openTermsModal = () => {
        termsModalRef.current.openModal();
    };

    const handleInputChange = (field, value) => {
        switch (field) {
            case 'name':
                setName(value);
                setNameV(false);
                break;
            case 'nickname':
                // Eliminar espacios y aceptar solo letras y números
                const sanitizedValue = value.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
                setNickname(sanitizedValue);
                setNicknameV(false);
                break;
            case 'email':
                setEmail(value);
                setEmailV(false);
                setEmailFormatV(esEmailValido(value));
                break;
            case 'phone':
                setPhone(value);
                setPhoneV(false);
                break;
            case 'Birthdate':
                setBirthdate(value);
                setBirthdateV(false);
                break;
            case 'password':
                setPassword(value);
                setPasswordV(false);
                break;
            case 'passwordRepeat':
                setPasswordRepeat(value);
                setPasswordRepeatV(false);
                setPasswordRepeatVerifiedV(value === password);
                break;
            case 'acceptTerms':
                setAcceptTerms(value);
                setAcceptTermsV(false);
                break;
            default:
                break;
        }
    };
    const handleImageChange = (event) => {
        const files = Array.from(event.target.files);
        setImages((prevImages) => {
            const newImages = [...prevImages, ...files];
            if (newImages.length > 3) {
                setImageV(true);
                return prevImages;
            } else {
                setImageV(false);
                return newImages;
            }
        });
    };

    return (
        <LayoutHomeUser>
            <div className="ap-screen ap-screen-inset -m-2 lg:-m-4 flex flex-col items-center justify-center min-h-[calc(100dvh-3.5rem)] px-4 py-10">
                <div className="w-full max-w-[420px]">
                    {/* Referido */}
                    {referrerName && (
                        <div className="ap-card flex items-center gap-3 px-4 py-3 mb-4 text-[14px]">
                            <LuVenetianMask className="shrink-0 text-lg" style={{ color: 'var(--ap-tint)' }} />
                            <span><strong>{referrerName}</strong> te ha invitado a la plataforma 🎉</span>
                        </div>
                    )}

                    <div className="ap-card p-5 sm:p-6">
                        <div className="flex justify-center mb-5 text-[50px]" style={{ color: 'var(--ap-tint)' }}>
                            {role == 'model' ? <LuVenetianMask /> : <FaRegUserCircle />}
                        </div>
                        <div className="ap-group">
                            {/* Email */}
                            <label className={`ap-row ${validate(emailV)}`}>
                                <LuMail className="ap-row-icon" />
                                <input
                                    type="email"
                                    inputMode="email"
                                    name="uniqueEmailField"
                                    aria-label="Email"
                                    value={email}
                                    onChange={(event) => handleInputChange('email', event.target.value)}
                                    placeholder="Your email"
                                    className="ap-input"
                                    disabled={isLoading}
                                    autoComplete="new-password"
                                />
                            </label>

                            {/* Password */}
                            <label className={`ap-row ${validate(passwordV)}`}>
                                <LuLock className="ap-row-icon" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="uniquePasswordField"
                                    aria-label="Password"
                                    value={password}
                                    onChange={(event) => handleInputChange('password', event.target.value)}
                                    placeholder="Password"
                                    className="ap-input"
                                    disabled={isLoading}
                                    autoComplete="new-password"
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                                    className="shrink-0 p-1 -mr-1"
                                    style={{ color: 'var(--ap-label-3)' }}
                                >
                                    {showPassword ? <LuEyeOff /> : <LuEye />}
                                </button>
                            </label>

                            {/* Password Repeat */}
                            <label className={`ap-row ${validate(passwordRepeatV || !passwordRepeatVerifiedV)}`}>
                                <LuKeyRound className="ap-row-icon" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    name="uniquePasswordRepeatField"
                                    aria-label="Repeat Password"
                                    value={passwordRepeat}
                                    onChange={(event) => handleInputChange('passwordRepeat', event.target.value)}
                                    placeholder="Repeat Password"
                                    className="ap-input"
                                    disabled={isLoading}
                                    autoComplete="new-password"
                                />
                            </label>
                        </div>
                        {emailV && <div className="ap-error">Valid email is required</div>}
                        {passwordV && <div className="ap-error">Password is required</div>}
                        {passwordRepeatV && <div className="ap-error">Password confirmation is required</div>}
                        {!passwordRepeatVerifiedV && <div className="ap-error">Passwords do not match</div>}

                        {/* Checkbox for terms and conditions */}
                        <label className={`flex items-start gap-3 mt-4 px-1 cursor-pointer ${acceptTermsV ? 'animate__animated animate__headShake' : ''}`}>
                            <input
                                type="checkbox"
                                name="uniqueAcceptTermsField"
                                checked={acceptTerms}
                                onChange={(event) => handleInputChange('acceptTerms', event.target.checked)}
                                className="ap-check"
                                disabled={isLoading}
                            />
                            <span className="ap-subhead">
                                I accept the <a href="#" onClick={(e) => { e.preventDefault(); openTermsModal(); }} className="ap-link">Terms and Conditions</a>
                            </span>
                        </label>
                        {acceptTermsV && <div className="ap-error">You must accept the terms and conditions</div>}

                        {/* Submit button */}
                        <button
                            onClick={login}
                            className="ap-btn ap-btn-filled w-full mt-5"
                            disabled={isLoading}
                        >
                            {isLoading ? <FaSpinner className="animate-spin" /> : 'Sign Up'}
                        </button>

                        {/* Google Sign-In */}
                        <div className="ap-divider my-5">Or sign up with</div>
                        <GoogleLoginButton darkMode={darkMode} role={role} isLoading={isLoading} setIsLoading={setIsLoading} />
                    </div>
                </div>
            </div>
            <Modal ref={modalRef} />
            <TermsModal ref={termsModalRef} />
            {modelWelcome === 'story' && <ModelWelcomeStory onFinish={() => setModelWelcome('hint')} />}
            {modelWelcome === 'hint' && <GoogleSignupHint darkMode={darkMode} onClose={() => setModelWelcome(null)} />}
        </LayoutHomeUser>
    );
}

export default Register;